import { gql } from '@apollo/client';

export const HOST_GROUPS = gql`
  query hostGroups {
    hostGroups {
      id
      title
      customization {
        color
      }
    }
  }
`;
